import React from 'react'
import { Button } from 'react-bootstrap'

import { useTranslation } from 'react-i18next'
import DeleteIcon from '../../../../components/icons/DeleteIcon'
import { HouseConsignmentRowData } from './types'

type HouseConsignmentsTableActionsProps = {
  selectedCount: number
  rows: HouseConsignmentRowData[]
  onClearSelection: () => void
  onDeleteSelected: () => void
  isBulkDeleteNotAllowed: boolean
  isBulkDeleting: boolean
}

function TransitHouseConsignmentsTableActions({
  selectedCount,
  rows,
  onDeleteSelected,
  onClearSelection,
  isBulkDeleteNotAllowed,
  isBulkDeleting,
}: HouseConsignmentsTableActionsProps) {
  const { t } = useTranslation()

  return (
    selectedCount > 0 ? (
      <div className="bulk-actions">
        <span className="bulk-actions__count">
          {t('table.rowsSelected', { selectedCount, total: rows.length })}
        </span>
        <div className="bulk-actions__buttons">
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={onClearSelection}
          >
            {t('common.clear')}
          </button>
          <Button
            variant="danger"
            size="sm"
            className="text-uppercase"
            onClick={onDeleteSelected}
            disabled={isBulkDeleteNotAllowed}
          >
            <DeleteIcon className="me-1" />
            {isBulkDeleting && <span className="spinner-border spinner-border-sm me-1" />}
            {t('table.deleteSelected')}
          </Button>
        </div>
      </div>
    ) : null
  )
}

export default TransitHouseConsignmentsTableActions
